module.exports = __webpack_public_path__ + "static/11-482b742c505678be276b62314bb9a029.jpg";